import { Component } from '@angular/core';

@Component({
  selector: 'app-career-coach',
  templateUrl: './career-coach.component.html',
  styleUrls: ['./career-coach.component.css'],
})
export class CareerCoachComponent {
  services = [
    {
      color: 'blue',
      img: ' ../../../assets/icon/lamp.png',
      title: 'Mantel, Physical Care',
      description:
        'With our online resume maker - you can select a template, import an existing resume or craft a new one from scratch within minutes.',
    },
    {
      color: 'pink',
      img: '../../../assets/icon/share.png',

      title: 'Increasing Welfare',
      description:
        'Share your CV with a convenient link via email or social media, and export as a PDF to apply directly to an employer.',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/paper.png',

      title: 'Career, Work business',
      description:
        "In today's competitive market, customization is key. Easily manage multiple VisualCV versions, personalized for each application.",
    },
    {
      color: 'pink',
      img: '/../../assets/icon/contact.svg',

      title: 'Solution Focused Therapy',
      description:
        'CV analytics will let you know when an employer views or downloads your CV.',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/privicy.png',

      title: 'Parenting Support & Skill',
      description:
        'We don’t share your information with anyone (unless you explicitly ask us to), and have 3 CV privacy options to ensure your data stays safe.',
    },
  ];
}
